import { useInfiniteQuery, useMutation, useQuery } from '@tanstack/react-query';
import axiosInstance from './axios';
import { GetCustomerResponse } from '../types/customerTypes';

export const useAddCustomer = (options = {}) => {
  return useMutation({
    mutationKey: ['useAddCustomer'],
    mutationFn: async (postData: {
      name?: string | null;
      email?: string | null;
      phoneNumber?: string | null;
      address?: string | null;
    }) => {
      const { data } = await axiosInstance.post('/customer', postData);
      // Throw error if API returns success: false
      return data;
    },
    ...options,
  });
};

export const useGetAllCustomers = ({
  customerName,
}: {
  customerName: string;
}) => {
  const postData = {
    pageNo: 0,
    pageSize: 10,
    customerName: customerName || '',
  };

  return useQuery({
    queryKey: ['useGetAllCustomers', postData],
    queryFn: async () => {
      const { data } = await axiosInstance.post(`/customer/all`, postData);
      return data as GetCustomerResponse;
    },
    // enabled: postData.enableFlag,
  });
};

// Separate from the fixed-page query used by existing consumers.
export const useInfiniteCustomerOptions = (customerName: string) =>
  useInfiniteQuery({
    queryKey: ['useInfiniteCustomerOptions', customerName],
    initialPageParam: 0,
    queryFn: async ({ pageParam, signal }) => {
      const { data } = await axiosInstance.post<GetCustomerResponse>(
        '/customer/all',
        { pageNo: pageParam, pageSize: 20, customerName },
        { signal }
      );
      return data;
    },
    getNextPageParam: (lastPage, _pages, lastPageParam) =>
      lastPageParam + 1 < lastPage.totalPages ? lastPageParam + 1 : undefined,
  });
